// extracted by mini-css-extract-plugin
export default {"wrap":"YF-z","fullWidth":"ZF-z","hideOnDesktop":"_F-z","content":"aG-z","hasOpenedNav":"bG-z","crumbsList":"cG-z","dropdownsWrap":"dG-z"};